export default "__VITE_ASSET__D7krLB$y__"